import React from 'react';
import { Link } from 'react-router-dom';
import { RiCheckDoubleLine } from 'react-icons/ri';

import { motion } from 'framer-motion';

export default function Card(props) {
  const childVariants = {
    hidden: {
      scale: 0,
    },
    visible: {
      scale: 1,
      transition: {
        staggerChildren: 0.5,
        when: 'beforeChildren',
      },
    },
  };

  function Card() {
    return (
      <motion.div
        variants={childVariants}
        initial="hidden"
        animate="visible"
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.1 }}
        className="product-card"
      >
        <motion.div className="product-card-img" variants={childVariants}>
          <img src={props.img} alt="toaster" />
        </motion.div>
        <motion.h3 variants={childVariants} className="product-card-name">
          Electronic Toaster
        </motion.h3>
        <motion.h4 variants={childVariants} className="product-card-price">
          Rs.3000
        </motion.h4>
        <motion.span variants={childVariants} className="product-card-assured">
          <RiCheckDoubleLine /> Assured
        </motion.span>
      </motion.div>
    );
  }
  return (
    <Link to="product/2323">
      <Card />
    </Link>
  );
}
